import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { referralSummary } from './shared/models/referralSummarySearchCriteria';
import { RefferalSummaryService } from './shared/services/refferal-summary.service';

@Component({
  selector: 'app-referral-summary',
  templateUrl: './referral-summary.component.html',
  styleUrls: ['./referral-summary.component.css']
})
export class ReferralSummaryComponent implements OnInit {

  referralSummarySearchCriteria: referralSummary;
  DateFrom : NgbDateStruct;
  DateTo : NgbDateStruct;
  referralSummary : any;
  maxDate: NgbDateStruct;

  constructor(private _referralSummarySvc : RefferalSummaryService, private _toasterSvc: ToastrService) { }

  ngOnInit(): void {
    this.resetForm();
    const current = new Date();
    this.maxDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
  }

  getReferralSummary(pageNo : any){
    this._referralSummarySvc.getReferralSummaryData

    
    this.referralSummarySearchCriteria.DateFrom = this.DateFrom.month + '/' + this.DateFrom.day + '/' + this.DateFrom.year;
    this.referralSummarySearchCriteria.DateTo = this.DateTo.month + '/' + this.DateTo.day + '/' + this.DateTo.year;
    this._referralSummarySvc.getReferralSummaryData(this.referralSummarySearchCriteria).subscribe(response => {
      if (response.ResultMessages.length > 0) {
        response.ResultMessages.forEach((res: any) => {
          this._toasterSvc.warning(res.Message);
          this.referralSummary = null;
        });
      }
      else {
        this.referralSummary = response?.ReferralSummary;
        console.log(response);
      }

    });
  }

  resetForm(){
    let from = new Date();
    let to = new Date();
    from.setDate(from.getDate() - 7);
    this.DateFrom = { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() }
    this.DateTo = { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
      this.referralSummarySearchCriteria = {
        DateFrom: (from.getMonth() + 1) + '/' + from.getDate() + '/' + from.getFullYear(),
        DateTo: (to.getMonth() + 1) + '/' + to.getDate() + '/' + to.getFullYear(),
        PageNo: 1,
        PageSize: 10,
        statusValue : null
      };
  }

  cancelSearch(){
    this.ngOnInit();
    this.referralSummary = null;
  }

}
